module.exports = __webpack_public_path__ + "static/img/radiotelescope.bc83e38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/radiotelescope.png
// module id = m1Mi
// module chunks = 1